var RoundStatus;
(function (RoundStatus) {
    RoundStatus[RoundStatus["Upcoming"] = 0] = "Upcoming";
    RoundStatus[RoundStatus["Started"] = 1] = "Started";
    RoundStatus[RoundStatus["Finished"] = 2] = "Finished";
    RoundStatus[RoundStatus["Canceled"] = 3] = "Canceled";
    RoundStatus[RoundStatus["OnFinish"] = 4] = "OnFinish";
    RoundStatus[RoundStatus["Open"] = 5] = "Open";
    RoundStatus[RoundStatus["OnHold"] = 6] = "OnHold";
})(RoundStatus || (RoundStatus = {}));

export { RoundStatus };
